import { RTOSuiteProvider } from 'src/lib/contexts/RTOSuiteProvider'
import RTOSuitePage from 'src/components/rto-suite/RTOSuitePage'

const RTOSuite = () => {
  return (
    <RTOSuiteProvider>
      <RTOSuitePage />
    </RTOSuiteProvider>
  )
}

export default RTOSuite
